<div *ngIf="!articleTable">Insights report loading ...</div>
<ng-container *ngIf="articleTable">
  <button edsSpacing="md" edsButton="primary" (click)="exportToExcel()">
    Export To Excel
  </button>
  <div class="ck-editor" [innerHtml]="articleTable | safeHtml"></div>
</ng-container>
